module.exports = __webpack_public_path__ + "img/login-img.9a5ba262.png";